import moment from 'moment-timezone';

/**
 * Return string of cs-CZ date format.
 *
 * @param {String} date Date string to be formated
 * @returns {String}
 */
export function formatForDatatable(date) {
  return moment(date).format('DD. MM. YYYY');
}

/**
 * Return string of cs-CZ date format with time.
 *
 * @param {String} date Date string to be formated
 * @returns {String}
 */
export function formatDateTime(date) {
  return moment(date).format('DD. MM. YYYY HH:mm');
}

/**
 * Return string of cs-CZ date format with time.
 *
 * @param {String} date Date string to be formated
 * @returns {String}
 */
export function formatDateTimeWithSeconds(date, timezone = null, utcOffset = null) {
  if (!date) {
    return null;
  }

  if (utcOffset !== null) {
    return moment(date).utcOffset(utcOffset).format('DD. MM. YYYY HH:mm:ss');
  }

  return moment(date)
    .tz(timezone || 'Europe/London')
    .format('DD. MM. YYYY HH:mm:ss');
}

/**
 * Return string of date format valid for api.
 *
 * @param {String} date Date string to be formated
 * @returns {String}
 */
export function formatForApi(date) {
  return date.length > 0 ? moment(date).format('DD-MM-YYYY hh:mm:ss') : null;
}
